const userPermission = {
  0: 'Usuário',
  1: 'Admin Sala',
  2: 'Admin Usuário',
  3: 'Master Admin',
}

export default userPermission
